import {
  AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  normalizeRenderConfig,
  sortReportRows,
} from "./renderConfig";
import { buildCsv } from "./agentServiceTimeExport";

const SUMMARY_HEADERS = Object.freeze([
  "Branch",
  "Service",
  "Agent",
  "Total",
  "%",
  "Average",
  "Min",
  "Max",
  "Completed",
  "Completed %",
  "No Show",
  "No Show %",
  "Unattended",
  "Unattended %",
]);

const toPrimitiveNumber = (value) => {
  const numericValue = Number(value);
  return Number.isFinite(numericValue) ? numericValue : 0;
};

export const getAgentTicketsPerServiceRows = (branch, service) => {
  const totalServiceData = toPrimitiveNumber(service.totalServiceData);
  return (service.agentsData || [])
    .filter((agent) => toPrimitiveNumber(agent?.total))
    .map((agent) => ({
      ...agent,
      branchName: branch.branchName || "",
      serviceName: service.serviceName || agent.serviceName || "",
      totalPct: totalServiceData ? (toPrimitiveNumber(agent.total) / totalServiceData) * 100 : 0,
    }));
};

export const getAgentTicketsPerServiceRowsByService = (branch, renderConfig) =>
  (branch.servicesData || []).map((service) => ({
    serviceName: service.serviceName || "",
    rows: sortReportRows(getAgentTicketsPerServiceRows(branch, service), renderConfig, {
      columnDefinitions: AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
    }),
  }));

export const getAgentTicketsPerServiceRowsByBranch = (branch, renderConfig) => {
  const config = normalizeRenderConfig(renderConfig, {
    columnDefinitions: AGENT_TICKETS_PER_SERVICE_COLUMN_DEFINITIONS,
  });
  return getAgentTicketsPerServiceRowsByService(branch, config).flatMap((service) => service.rows);
};

export const getAgentTicketsPerServiceSummaryCsvRows = (branches = [], renderConfig) =>
  branches.flatMap((branch) =>
    getAgentTicketsPerServiceRowsByBranch(branch, renderConfig).map((row) => [
      row.branchName || "",
      row.serviceName || "",
      row.agentName || "",
      toPrimitiveNumber(row.total),
      toPrimitiveNumber(row.totalPct),
      toPrimitiveNumber(row.average),
      toPrimitiveNumber(row.min),
      toPrimitiveNumber(row.max),
      toPrimitiveNumber(row.numCompleted),
      toPrimitiveNumber(row.pctCompleted),
      toPrimitiveNumber(row.numNoShow),
      toPrimitiveNumber(row.pctNoShow),
      toPrimitiveNumber(row.numUnattended),
      toPrimitiveNumber(row.pctUnattended),
    ])
  );

const triggerCsvDownload = (filename, csv) => {
  const blob = new Blob([csv], { type: "text/csv;charset=utf-8" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
};

export const downloadAgentTicketsPerServiceCsvFile = ({ data, renderConfig }) => {
  triggerCsvDownload(
    "branch_agent_tickets_per_service_summary.csv",
    buildCsv(SUMMARY_HEADERS, getAgentTicketsPerServiceSummaryCsvRows(data, renderConfig))
  );
};
